import { render } from "./Transactions.vue?vue&type=template&id=0faea410&scoped=true&ts=true"
import script from "./Transactions.vue?vue&type=script&lang=ts"
export * from "./Transactions.vue?vue&type=script&lang=ts"

import "./Transactions.vue?vue&type=style&index=0&id=0faea410&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faea410"]])

export default __exports__